<script>
import TwInput from '@/components/generic/forms/tw-input.vue'
import TwCard from '@/components/generic/tw-card.vue'

export default {
  name: 'AddressEditCard',
  components: { TwCard, TwInput },
  props: {
    modelValue: {
      type: Object,
      default: () => ({
        address_street: null,
        address_city: null,
        address_state: null,
        address_zip: null,
      })
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      Address: {
        ...this.modelValue
      }
    }
  },
  watch: {
    modelValue: {
      handler(newVal) {
        // this is in case it changes from the outside
        // console.log('address coming from outside', newVal)
        this.Address = { ...newVal };
      },
      deep: true
    }
  },
  methods: {
    updateAddress () {
      this.$emit('update:modelValue', this.Address)
    }
  }
}
</script>

<template>
  <div class="grid sm:grid-cols-2 gap-2 sm:gap-4 mb-2">
    <tw-input v-model="Address.address_street" required label="Address" @input="updateAddress" />
    <tw-input v-model="Address.address_city" required label="City" @input="updateAddress" />
  </div>
  <div class="grid sm:grid-cols-2 gap-2 sm:gap-4 mb-2">
    <tw-input v-model="Address.address_state" required label="State" @input="updateAddress" />
    <tw-input v-model="Address.address_zip" required label="Zip Code" @input="updateAddress" />
  </div>
</template>

<style scoped>

</style>
